/********************
Switched to using css selectors. Keeping
this here just in case
**********************
const calloutPanels = document.querySelectorAll('.callout-5050__panel');
const calloutPanelsMediaQuery = window.matchMedia('(min-width: 782px)');

function handleMouseEnter(event) {
	const { target: panel } = event;
	panel.classList.add('is-open');
	panel.parentElement.classList.add('has-open-panel');

	if (panel.classList.contains('callout-5050__left')) {
		panel.parentElement.parentElement.parentElement.classList.add(
			'callout-5050--navy'
		);
		panel.nextElementSibling.classList.add('is-hidden');
	}

	if (panel.classList.contains('callout-5050__right')) {
		panel.parentElement.parentElement.parentElement.classList.add(
			'callout-5050--white'
		);
		panel.previousElementSibling.classList.add('is-hidden');
	}
}

function handleMouseLeave(event) {
	const { target: panel } = event;
	panel.classList.remove('is-open');
	panel.parentElement.classList.remove('has-open-panel');
	const panels = document.querySelectorAll('.callout-5050__panel');
	panels.forEach((item) => {
		item.classList.remove('is-hidden');
	});
	document
		.querySelector('.callout-5050')
		.classList.remove('callout-5050--navy');
	document
		.querySelector('.callout-5050')
		.classList.remove('callout-5050--white');
}

if (calloutPanels.length > 1) {
	calloutPanels.forEach((panel) => {
		panel.addEventListener('mouseenter', handleMouseEnter);
		panel.addEventListener('mouseleave', handleMouseLeave);
	});
}
*/
